import { GobalInputValidationEvent } from "../../factorys/inputvalidation/events/GobalInputValidationEvent";

export default class InputValidationService {

  private static _f: InputValidationService | null = null;
  public static get factory(): InputValidationService {
    if (this._f != null) return this._f; this._f = new InputValidationService();
    return this._f;
  }

  public dispatchGobalInputValidationEventvent() {

    window.dispatchEvent(new GobalInputValidationEvent());
  }
}